
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thu-moi-hop-co-dong-2026",
      function () {
        return require("private-next-pages/thu-moi-hop-co-dong-2026/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thu-moi-hop-co-dong-2026"])
      });
    }
  